import BaseBehavior from '../../foundation/base/base';

/* global CookieInformation */
/* global CookieConsent */

const COOKIE_CATEGORIES = [
	'cookie_cat_functional',
	'cookie_cat_statistic'
];

const consentGiven = category => CookieInformation.getConsentGivenFor(category);

class Personalization extends BaseBehavior {
	constructor(element) {
		super(element);

		this.element = element;
		this.initDomCache();

		this.items = this.dom.items;
		this.block = this.dom.block;
		this.button = this.dom.renew;

		this.addEventListener();
	}

	addEventListener() {
		if (CookieInformation) {
			window.addEventListener('CookieInformationConsentGiven', () => {
				this.checkCookieAccept();
			});
		}

		this.checkCookieAccept();
		this.button.addEventListener('click', () => {
			if (CookieConsent) {
				CookieConsent.renew();
			}
		});
	}

	checkCookieAccept() {
		const allAccepted = COOKIE_CATEGORIES.every(consentGiven);

		if (allAccepted) {
			this.loaditems();
		} else {
			this.unloaditems();
		}
	}

	loaditems() {
		this.block.style.display = 'none';
	}

	unloaditems() {
		this.block.style.display = 'inherit';
	}
}

export default Personalization;
